import useIsMobile from "../../hooks/useIsMobile";

type LogMessageProps = {
  text: {
    subject: string;
    other_text: string;
    complement: string;
  };
  bgColor?: string;
  normalTextColor?: string;
  highlightedTextColor?: string;
  shifted?: boolean;
};

const LogMessage = (props: LogMessageProps) => {
  const { isMobile } = useIsMobile();
  return (
    <div className="log-message-wrapper">
      <div
        className={`log-message ${props.shifted && "shifted"}`}
        style={{
          backgroundColor: props.bgColor,
          width: isMobile ? "calc(332px - 40px)" : "",
          padding: isMobile ? "0 20px" : "",
          marginBottom: isMobile ? "40px" : "",
        }}
      >
        <span>
          <strong>{props.text.subject}</strong>
          {props.text.other_text}
          <strong> {props.text.complement}</strong>
        </span>
      </div>
    </div>
  );
};
export default LogMessage;
